import { FC, useEffect, useState } from "react"
import { AirportContact, AirportContacts } from "../../api/AirportContacts"
import { getAirportContacts, getCountries } from "../../api/BackendCalls"
import { Countries } from "../../api/Countries"
import { useAppSelector } from "../../app/hooks"
import { HandlingApp, PageId } from "../../common/pageId"
import { PageContent } from "../../common/pageText"
import { FieldName } from "../../common/text"
import DropdownField, {
  ValueLabel
} from "../../components/generic/form/DropdownField"

import { PageTemplate } from "../../components/pageTemplate/PageTemplate"

export const Contact: FC = () => {
  const [airport, setAirport] = useState<string>(null)
  const [country, setCountry] = useState<string>(null)
  const [countries, setCountries] = useState<Countries>([])
  const [airportContacts, setAirportContacts] = useState<AirportContacts>([])
  const { versionInfo } = useAppSelector((state) => state["appReducer"])
  const isPPR = versionInfo.handlingApplication === HandlingApp.FRAPORTGR

  const handleGetAirports = () => {
    setAirportContacts([])
    setAirport(null)
    if (country) {
      getAirportContacts(PageId.ContactUs, { country: country }, (contacts) => {
        setAirportContacts(contacts)
      })
    }
  }

  useEffect(() => {
    handleGetAirports()
    // eslint-disable-next-line
  }, [country])

  useEffect(() => {
    getCountries(PageId.ContactUs, (countries) => {
      setCountries(countries)
    })
  }, [])

  const countryOpts: ValueLabel[] = countries.map((c) => ({
    label: c.name,
    value: c.code
  }))

  const airportOpts: ValueLabel[] = airportContacts.map((ac) => ({
    label: ac.airport,
    value: ac.airport
  }))

  const OOHContactInfo: AirportContact = airportContacts.find(
    (ac) => ac.airport === airport
  )

  return (
    <PageTemplate
      pageTitle={PageContent.contactUs}
      pageContentClassName="info-page-container"
    >
      <article className="contact-container d-flex flex-wrap justify-content-center">
        <section className="contact-section info-page-txt">
          <header>Contact Information</header>
          {isPPR ? (
            <>
              <p>
                For any issues related to account settings (new or locked
                account) please send mail to our Service Desk.
              </p>
              <p>
                <span className="bold">Email:</span>{" "}
                <a href="mailto:ITT-servicedesk@fraport-greece.com">
                  ITT-servicedesk@fraport-greece.com.
                </a>
              </p>
              <p className="m-0">
                For any other issues (eg. missing operator/airport/aircraft
                type), please send mail to XXXppr@fraport-greece.com (where XXX
                is the 3-letter IATA airport code).
              </p>
              <p className="italic">
                For example, if requested PPR concerns JMK airport, the relevant
                mail should be sent to JMKppr@fraport-greece.com.
              </p>
            </>
          ) : (
            <>
              <p>
                If you are experiencing problems with the Online Coordination
                System, please contact the Customer Service Center (CSC).
              </p>
              <p>
                The CSC is open weekdays from 0800 to 1800 UK local time and can
                be contacted by either email or telephone.
              </p>
              <p>
                <span className="bold">Email:</span>{" "}
                <a href="mailto:help@online-coordination.com">
                  help@online-coordination.com
                </a>
              </p>
              <p>
                <span className="bold">Phone:</span> +44 (0)20 8564 0600
              </p>
              <p className="m-0 bold">Postal Address:</p>
              <p className="m-0">OCS Portal Administrator</p>
              <p className="m-0">c/o Airport Coordination Limited</p>
              <p className="m-0">Online Coordination</p>
              <p className="m-0">01 Meadlake Place</p>
              <p className="m-0">Thorpe Lea Road</p>
              <p className="m-0">Egham</p>
              <p className="m-0">Surrey</p>
              <p className="m-0">TW20 8HE</p>
              <p className="">United Kingdom</p>
            </>
          )}
        </section>
        {!isPPR && (
          <section className="contact-section info-page-txt">
            <header>Out of Hours Contact</header>
            <p>
              Outside CSC office hours, you may contact specific contacts for
              some airports.
            </p>
            <p>
              Please select country to retrieve airports with OOH contact
              information, and then select airport.
            </p>
            <div className="d-flex ocs-mt-20px">
              <div className="ocs-mr-12 ocs-w-220">
                <DropdownField
                  name={FieldName.countries}
                  caption="Country"
                  clearable
                  closeOnSelect={true}
                  options={countryOpts}
                  value={country}
                  onChange={(name, val) => {
                    setCountry(val)
                  }}
                  menuPortalTarget={document.body}
                />
              </div>
              <div className={"ocs-w-100"}>
                <DropdownField
                  name={FieldName.airports}
                  required
                  caption="Airport"
                  clearable
                  closeOnSelect
                  options={airportOpts}
                  value={airport}
                  onChange={(name, val) => {
                    setAirport(val)
                  }}
                />
              </div>
            </div>
            {OOHContactInfo && (
              <div className="ocs-mt-20px">
                <p className="bold m-0">Contact Information</p>
                <p>{OOHContactInfo.oohContact}</p>
              </div>
            )}
          </section>
        )}
      </article>
    </PageTemplate>
  )
}
